<template>
  <div class="empty-state-centered tw-mx-auto tw-max-w-[70%]">
    <slot>
      <slot name="custom-top" />
      <h1 class="tw-m-0" v-if="boldMessage">
        {{ boldMessage }}
      </h1>
      <h3 v-if="message" class="empty-message">
        {{ message }}
      </h3>
      <ActionButtons
        v-if="actions"
        :actions="actions"
        class="empty-action-buttons"
        :testId="testId"
      />
      <div class="nx-text-body3" v-if="subMessage">
        {{ subMessage }}
      </div>
      <div
        v-for="(h, i) in help"
        :key="i"
        class="nx-text-body3 tw-mt-1"
        :class="{ disabled: h.disabled }"
      >
        <a
          href="#"
          @click="execute(h)"
          :data-test="`${h.name.toLowerCase().replaceAll(' ', '-')}-btn`"
          >{{ h.name }}</a
        >
      </div>
      <slot name="custom" />
    </slot>
  </div>
</template>

<script>
import ActionButtons from "@/components/display/ActionButtons";

export default {
  name: "EmptyState",
  components: {
    ActionButtons,
  },
  props: {
    testId: {
      type: String,
      default: "",
    },
    actions: Array,
    help: Array,
    boldMessage: String,
    message: String,
    subMessage: String,
  },
  setup() {
    const execute = (action) => action.action();

    return {
      execute,
    };
  },
};
</script>

<style lang="scss" scoped>
.empty-state-centered {
  text-align: center;
  margin-top: 2.5rem;
  margin-bottom: 2.125rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  .empty-message {
    margin-top: 1rem;
    margin-bottom: 0px;
    font-weight: 400;
  }
  .empty-action-buttons {
    margin-top: 2.5rem;
    margin-bottom: 1rem;
  }
}
</style>
